<template>
  <div class="home">
    <h1 class="display-1 pageTitle">{{ $t("IMAGE_PREVIEW_HEADER") }}</h1>
    <div class="previewIntro">
      <p class="subheading" v-html="imagePreviewText"></p>
      <ShopNavigationActions :step="2" class="d-none d-md-flex"/>
    </div>
    <v-card v-if="active" class="imageContainer imagePresentation">
      <v-container grid-list-sm fluid>
        <VirtualScroll
            :active="active"
            :initial-items-count="8"
            :preload-padding="getImageHeight()"
            :items="imageSelection.images"
            :visible-window="window"
            class="imageLayout"
            v-masonry
            column-width="137"
            gutter="8"
            transition-duration="0s"
        >
          <template scope="{item, index}">
            <div v-masonry-tile
                 :style="{width: getImageWidth(item) + 'px'}"
                 :class="{imageSelectionDiv: true, landscape: item.orientation === 'LANDSCAPE', portrait: item.orientation === 'PORTRAIT'}"
            >
              <ImagePreview
                  class="imageItem"
                  :image="item"
                  :small-height="getImageHeight() + 'px'"
                  :small-width="getImageWidth(item) + 'px'"
                  :ref="`preview-${index}`"
                  :hasPreviousPreview="hasPreviousPreview(index)"
                  :hasNextPreview="hasNextPreview(index)"
                  @openPrevious="openPreview(index-1)"
                  @openNext="openPreview(index+1)"
              />
            </div>
          </template>
        </VirtualScroll>
      </v-container>
    </v-card>

    <div class="shopNavigationButtons previewBottomNavigation">
      <v-btn color="primary" @click="select">{{ $t("BUTTON_CONTINUE") }}</v-btn>
    </div>
    <NewsletterDialog/>
  </div>
</template>

<script lang="ts">
import Component from "vue-class-component";
import ImagePreview from "@/components/ImagePreview.vue";
import BasicComponent from "@/global/BasicComponent";
import NewsletterDialog from "@/components/NewsletterDialog.vue";
import {ImageCollectionDto, ImageDto, ImageOrientationDto} from "@swagger";
import VirtualScroll from "@/components/VirtualScroll.vue";
import ShopNavigationActions from "@/components/ShopNavigationActions.vue";
//import Masonry from "masonry-layout";

@Component({
  components: {ShopNavigationActions, VirtualScroll, NewsletterDialog, ImagePreview}
})
export default class ImagePresentation extends BasicComponent {

  loading: boolean = false;
  displayImages: number = 8;

  select() {
    this.setStep(3);
  }

  back() {
    this.setStep(1);
  }

  hasPreviousPreview(index) {
    return this.imageSelection.images[index - 1] != undefined;
  }

  hasNextPreview(index) {
    return this.imageSelection.images[index + 1] != undefined;
  }

  openPreview(index) {
    const preview = this.$refs[`preview-${index}`] as ImagePreview;
    preview.openDialog();
  }

  get active() {
    return Number(this.$store.getters.step) === 2;
  }

  get imageSelection(): ImageCollectionDto {
    if (!this.$store.getters.imageSelection) {
      return {images: [], persons: []};
    }
    return this.$store.getters.imageSelection;
  }

  get selection() {
    return this.$store.getters.image;
  }

  set selection(image) {
    this.$store.commit("setImage", image);
  }

  get imagePreviewText() {
    return this.$t("IMAGE_PREVIEW_TEXT").toString();//.replace("{expiryDate}", this.imageSelection.expiryDate)
  }

  get window(): Window {
    return window;
  }

  getImageHeight(): number {
    return 192;
  }

  getImageWidth(image: ImageDto): number {
    return image.orientation === ImageOrientationDto.LANDSCAPE ? 282 : 137;
  }

  getImageUrl(image) {
    return image;
  }

  getNextPreview(index) {
    return this.$refs[`preview-${index + 1}`];
  }

}
</script>
<style scoped lang="scss">

.pageTitle {


  margin-bottom: 12px;


}
@media (min-width: 960px) {
  .previewIntro {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;

    .subheading {

      margin-bottom: 0;

    }
  }
}

* {
  box-sizing: border-box;
}

.otherCodeButtonContainer {
  @media screen and (max-width: 360px) {
    padding-right: 0;

    button {
      padding: 0 8px !important;
    }
  }
}

.md-card {
  max-width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.imageContainer {

  margin-left: 2px;
  margin-right: 2px;

  .container {
    @media screen and (max-width: 320px) {
      padding: 10px !important;
    }
  }

  .imageLayout {
    width: 100%;
    height: 100%;
    /*
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax($cellSize, 1fr));
    grid-auto-rows: $cellSize;
    grid-auto-flow: dense;
    grid-gap: 10px;
    margin: 1em;
    padding: 0;
    */

    /*
    * {
        flex-basis: 10px;
        &:not(:last-of-type) {
            //margin-right: 25px;
        }
    }
    */

  }
}

.actions {
  flex-wrap: wrap !important;
}

.selectionButton {
  margin-top: 10px;
}

</style>

<style lang="scss">

.imageItem {
  margin-bottom: 10px;
}

.imagePresentation {
  .imageSelectionDiv {
    padding-bottom: 8px;
    /*
  list-style-type: none;
  position: relative;
  padding: 0;
  overflow: hidden;

  $spanWide: 15;
  $spanSlim: 10;

  &.portrait {
      grid-row: span $spanWide;
      grid-column: span $spanSlim;
  }

  &.landscape {
      grid-column: span $spanWide;
      grid-row: span $spanSlim;
  }
  */

    .imageSelection {
      &:hover {
        cursor: pointer;
      }
    }

    /*
  .v-image {
      display: block;
      -o-object-fit: cover;
      object-fit: cover;
      height: 100%;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
  }
  */

    /*
  img {
      height: 128px;
      width: auto !important;
  }
   */

  }
}

</style>

<style scoped lang="scss">
.previewBottomNavigation {

  margin-top: 16px;

  justify-content: flex-end;

}</style>
